export const actionTypes = {
  // get
  GET_FOREX_RATE_START: 'GET_FOREX_RATE_START',
  GET_FOREX_RATE_SUCCESS: 'GET_FOREX_RATE_SUCCESS',
  GET_FOREX_RATE_FINISH: 'GET_FOREX_RATE_FINISH',

  // create
  CREATE_FOREX_RATE_START: 'CREATE_FOREX_RATE_START',
  CREATE_FOREX_RATE_SUCCESS: 'CREATE_FOREX_RATE_SUCCESS',
  CREATE_FOREX_RATE_FINISH: 'CREATE_FOREX_RATE_FINISH',
  CREATE_FOREX_RATE_RESET: 'CREATE_FOREX_RATE_RESET',

  // update
  UPDATE_FOREX_RATE_START: 'UPDATE_FOREX_RATE_START',
  UPDATE_FOREX_RATE_SUCCESS: 'UPDATE_FOREX_RATE_SUCCESS',
  UPDATE_FOREX_RATE_FINISH: 'UPDATE_FOREX_RATE_FINISH',
  UPDATE_FOREX_RATE_RESET: 'UPDATE_FOREX_RATE_RESET',

  //Activate deactivate
  ACTIVATE_FOREX_RATE_REQUEST: 'ACTIVATE_FOREX_RATE_REQUEST',
  ACTIVATE_FOREX_RATE_SUCCESS: 'ACTIVATE_FOREX_RATE_SUCCESS',
  ACTIVATE_FOREX_RATE_FINISH: 'ACTIVATE_FOREX_RATE_FINISH',

  SINGLE_ACTIVATE_FOREX_RATE_REQUEST: 'SINGLE_ACTIVATE_FOREX_RATE_REQUEST',
  SINGLE_ACTIVATE_FOREX_RATE_SUCCESS: 'SINGLE_ACTIVATE_FOREX_RATE_SUCCESS',
  SINGLE_ACTIVATE_FOREX_RATE_FINISH: 'SINGLE_ACTIVATE_FOREX_RATE_FINISH',

  SINGLE_DEACTIVATE_FOREX_RATE_REQUEST: 'SINGLE_DEACTIVATE_FOREX_RATE_REQUEST',
  SINGLE_DEACTIVATE_FOREX_RATE_SUCCESS: 'SINGLE_DEACTIVATE_FOREX_RATE_SUCCESS',
  SINGLE_DEACTIVATE_FOREX_RATE_FINISH: 'SINGLE_DEACTIVATE_FOREX_RATE_FINISH',

  DEACTIVATE_FOREX_RATE_REQUEST: 'DEACTIVATE_FOREX_RATE_REQUEST',
  DEACTIVATE_FOREX_RATE_SUCCESS: 'DEACTIVATE_FOREX_RATE_SUCCESS',
  DEACTIVATE_FOREX_RATE_FINISH: 'DEACTIVATE_FOREX_RATE_FINISH',

  // delete
  DELETE_FOREX_RATE_START: 'DELETE_FOREX_RATE_START',
  DELETE_FOREX_RATE_SUCCESS: 'DELETE_FOREX_RATE_SUCCESS',
  DELETE_FOREX_RATE_FINISH: 'DELETE_FOREX_RATE_FINISH',

  // get File csv xlsx
  GET_FOREX_RATE_FILE_START: 'GET_FOREX_RATE_FILE_START',
  GET_FOREX_RATE_FILE_SUCCESS: 'GET_FOREX_RATE_FILE_SUCCESS',
  GET_FOREX_RATE_FILE_FINISH: 'GET_FOREX_RATE_FILE_FINISH',

  // Import forex rate
  IMPORT_FOREX_RATE_START: 'IMPORT_FOREX_RATE_START',
  IMPORT_FOREX_RATE_SUCCESS: 'IMPORT_FOREX_RATE_SUCCESS',
  IMPORT_FOREX_RATE_FINISH: 'IMPORT_FOREX_RATE_FINISH',
}
